// extracted by mini-css-extract-plugin
var _1 = "DefaultHeader_headerContent__5f950";
var _2 = "DefaultHeader_root__1cc5d";
export { _1 as "headerContent", _2 as "root" }
